import { Component, OnInit } from '@angular/core';
import { Question } from 'src/app/interfaces/questions/quetions.interface';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss'],
})
export class QuestionsComponent implements OnInit {
  selectedTopic: string | null = null;
  searchTerm: string = '';
  topics: string[] = [
    'Programa Shell Box',
    'Puntos Shell Box',
    'Canje de Puntos Shell Box',
    'Conversor de puntos',
    'Canje de Beneficios',
    'Condiciones de Uso del Programa',
    'App Shell Box',
    'Market Shell',
    'Centro de atención',
  ];

  questions: Question[] = [
    {
      topic: 'Programa Shell Box',
      question: '¿Qué es el Programa de Beneficios Shell Box?',
      answer: `Shell Box es el programa de fidelización de Shell y es nuestra forma de premiar con un valor agregado a nuestros clientes. Al asociarte al programa de beneficios Shell Box podrás:
          <ol>
            <li>
              Acumular puntos con cada compra de Shell V-Power Nafta o Diesel, Shell Fórmula Súper, lubricantes Shell Helix, Shell Rimula y Shell Advance o también en las tiendas Shell Select de nuestras Estaciones de Servicio adheridas.
            </li>
            <li>
              Canjear los puntos acumulados por descuentos en Shell V-Power Nafta o Diesel, Lubricantes Shell Helix, Shell Rimula y Shell Advance o también en las tiendas Shell Select de las Estaciones de Servicio adheridas.
            </li>
            <li>Canjear Puntos en el Market Shell.</li>
            <li>Acceder a descuentos y promociones exclusivas</li>
          </ol>`,
    },
    {
      topic: 'Programa Shell Box',
      question: '¿Cómo puedo acceder al programa? ¿Tiene costo?',
      answer: `La asociación al programa es voluntaria y no tiene costo alguno para el socio. El cliente podrá asociarse de las siguientes maneras:
          <ul>
            <li>
              A) A través de nuestra página web haciendo clic <a href="https://www.shellbox.ar/ingresar" target="_blank" rel="noopener noreferrer">acá</a>.
            </li>
            <li>
              B) A través de nuestra App Shell Box, completando los pasos de registro. Podés descargar la app tanto en Google Play (Android) como en App Store (IOS).
            </li>
          </ul>`,
    },
    {
      topic: 'Programa Shell Box',
      question:
        '¿Necesito tener la App Shell Box para pertenecer al programa de beneficios?',
      answer: `No es necesario usar la App Shell Box para pertenecer al programa de beneficios. Podrás acumular, canjear puntos y acceder a los principales beneficios del programa registrándote a través de la web haciendo clic <a href="https://shellbox.shell.com.ar/ingresar" target="_blank" rel="noopener noreferrer">acá</a> y presentando tu DNI en las estaciones de servicio adheridas podrás acceder a las acumulaciones y canjes de puntos Shell Box.`,
    },
    {
      topic: 'Programa Shell Box',
      question: '¿Participan todas las estaciones de Shell?',
      answer: `No, participan únicamente las estaciones de servicio de Shell Argentina que están adheridas al programa. Podrás encontrar el detalle en "estaciones cercanas" o haciendo clic <a href="https://shellbox.shell.com.ar/app" target="_blank">acá</a>.`,
    },
    {
      topic: 'Programa Shell Box',
      question:
        '¿Dónde puedo consultar las ofertas y promociones del programa de Shell Box?',
      answer: `Podés consultar ofertas y promociones en la App Shell Box en la sección “descuentos vigentes” que se encuentra en el menú de inicio. Los beneficios los vas a poder visualizar a través de la web <a href="https://shellbox.shell.com.ar/beneficios-y-descuentos" target="_blank">https://shellbox.shell.com.ar/beneficios-y-descuentos</a>.`,
    },
    {
      topic: 'Puntos Shell Box',
      question: 'En mi primera compra, ¿puedo sumar puntos?',
      answer: `Una vez registrado exitosamente desde la App Shell Box o haciendo clic <a href="https://shellbox.shell.com.ar/ingresar" target="_blank" rel="noopener noreferrer">acá</a>, empezarás a acumular puntos con cada compra que realices abonando con la app o presentando el DNI al momento de abonar.`,
    },
    {
      topic: 'Puntos Shell Box',
      question: '¿Necesito presentar una tarjeta para acumular puntos?',
      answer: `No, si tu compra es abonada a través de la App Shell Box tus puntos se sumarán automáticamente. Si no utilizás este medio de pago, presentando tu DNI al momento de abonar el vendedor se encargará de acreditar los puntos en tu cuenta.`,
    },
    {
      topic: 'Puntos Shell Box',
      question: '¿Qué productos acumulan puntos?',
      answer: `Podrás acumular puntos con la compra de: Shell V-Power Nafta o Diesel, Shell Fórmula Súper, lubricantes Shell Helix, Shell Rimula y Shell Advance o también en las tiendas Shell Select de nuestras Estaciones de Servicio adheridas.`,
    },
    {
      topic: 'Puntos Shell Box',
      question: '¿Cómo puedo verificar los puntos sumados en cada compra?',
      answer: `Podrás verificar los puntos acumulados en el histórico de puntos, que se encuentra dentro de la web y en la App Shell Box. También vas a poder consultar tus puntos en las estaciones de servicio adheridas al programa.`,
    },
    {
      topic: 'Puntos Shell Box',
      question: '¿Hay algún límite en la acumulación de puntos?',
      answer: `El programa Shell Box cuenta con controles de prevención de fraude que limitan la asignación de puntos en transacciones potencialmente sospechosas. Igualmente, el Socio puede realizar un reclamo solicitando la acumulación de puntos. Para ello, contactarse con el Centro de Atención al Socio, para que se gestione la correcta acreditación de puntos de la compra realizada.`,
    },
    {
      topic: 'Puntos Shell Box',
      question: '¿Cuál es la carga mínima para obtener puntos?',
      answer: `
          <p>Para combustibles no existen mínimos de cargas para obtener puntos.</p>
          <p>A partir de la compra de 1 unidad (una) de Lubricantes Premium (Helix, Rimula & Advance).</p>
          <p>A partir de la compra de 1 unidad (una) de Lubricantes Regular (Helix, Rimula & Advance).</p>
          <p>A partir de una compra superior a los $150 en nuestras tiendas Shell Select (exceptuando productos no habilitados).</p>`,
    },
    {
      topic: 'Puntos Shell Box',
      question:
        '¿Qué sucede si al momento de realizar mi compra el vendedor no me acredita los puntos?',
      answer: `Si al momento de realizar tu compra no se te acreditaron los puntos, deberás iniciar un reclamo para que nuestra Mesa de Ayuda pueda acreditarte los puntos. Deberás presentar el ticket factura y número de DNI. Horario de atención de lunes a viernes, 10 a 16hs. Puedes comunicarte a través del número <a href="tel:08103338652">0810-333-8652</a> o enviar un correo a <a href="mailto:shellbox@raizen.com.ar">shellbox@raizen.com.ar</a>.`,
    },
    {
      topic: 'Puntos Shell Box',
      question:
        '¿Los puntos se acreditan automáticamente? ¿Qué debo hacer si no se me acreditaron?',
      answer: `Los puntos se acreditan en la cuenta de Shell Box, durante el transcurso del día en que la transacción se llevó a cabo. Vas a poder llevar registro de tus puntos en el “historial de puntos” tanto desde la App como desde el sitio Web. Ante cualquier duda, te podrás contactar con nuestro Call Center.`,
    },
    {
      topic: 'Puntos Shell Box',
      question: '¿Los puntos tienen vencimiento?',
      answer: `Sí, los puntos vencen a los 3 años (36 meses).`,
    },
    {
      topic: 'Canje de Puntos Shell Box',
      question: '¿Por qué productos/servicios puedo canjear los puntos?',
      answer: `Vas a poder canjear tus puntos tanto en la EESS por descuentos en combustible V-Power, Lubricantes y Tiendas Shell Select. Además vas a poder canjear tus puntos para participar por alguno de nuestros sorteos publicados en la web de Shell Box o por productos del Market Shell.`,
    },
    {
      topic: 'Canje de Puntos Shell Box',
      question: '¿Cómo hago para canjear los puntos?',
      answer: `Para canjes en combustible V-Power, Lubricantes y Tienda Shell Select, lo vas a poder hacer a través de la App Shell Box seleccionando el voucher que desees luego de escanear el QR, o también podrás canjearlos presentando el DNI al vendedor en la estación de servicio.`,
    },
    {
      topic: 'Canje de Puntos Shell Box',
      question:
        '¿Cuáles son las distintas opciones de canje que hay en las estaciones de servicio de Shell?',
      answer: `Con los puntos Shell Box acumulados, podrás acceder mediante canjes a distintos vouchers de descuento, en las estaciones de servicio adheridas al programa. Las distintas opciones de canje disponibles son:
          <p>
            550 puntos (voucher de $800), 1.100 puntos (voucher de $1.600), 1.650 puntos (voucher de $2.400), 2.200 puntos (voucher de $3.200) y 3.300 puntos (voucher de $4.800).
          </p>`,
    },
    {
      topic: 'Conversor de puntos',
      question: '¿Qué es el conversor de puntos? ¿Para qué me sirve?',
      answer: `A través del conversor de puntos podrás utilizar las millas LATAM Pass para convertirlos por Puntos Shell Box.`,
    },
    {
      topic: 'Conversor de puntos',
      question: '¿Dónde voy a poder convertir puntos?',
      answer: `La conversión de puntos la podrás realizar desde la página web haciendo clic <a href="https://shellbox.shell.com.ar/conversor" target="_blank" rel="noopener noreferrer">acá</a> o desde la App ingresando al Conversor de Puntos.`,
    },
    {
      topic: 'Conversor de puntos',
      question: '¿Hay un límite para la conversión de puntos?',
      answer: `Sí, existen límites mensuales para convertir puntos Shell Box. Dichos límites estarán indicados en el momento de realizar la transacción.`,
    },
    {
      topic: 'Conversor de puntos',
      question:
        '¿Voy a poder canjear mis millas acumuladas en el programa de Shell LATAM Pass para ahorro en combustible?',
      answer: `Podrás realizar el canje de Millas Latam Pass por Puntos Shell Box mediante nuestro conversor de puntos disponible desde la App o desde la Web. Luego podrás utilizar dichos puntos para obtener los beneficios del programa.`,
    },
    {
      topic: 'Canje de Beneficios',
      question: '¿Quiénes pueden acceder a los beneficios de Shell Box?',
      answer: `Cualquier persona que sea socia del programa de beneficios de Shell Box podrá acceder a los beneficios.`,
    },
    {
      topic: 'Canje de Beneficios',
      question:
        '¿Cómo hago para obtener los códigos de descuento de los distintos beneficios de Shell Box?',
      answer: `Una vez iniciado sesión en <a href="https://www.shellbox.ar" target="_blank" rel="noopener noreferrer">www.shellbox.ar</a>, en la sección “Beneficios” deberás seleccionar el beneficio de interés y la opción “Quiero mi beneficio”. Al seleccionar esta opción obtendrás un cupón para utilizar y acceder al descuento. En algunos casos el cupón se redime a través de la página web del negocio seleccionado, y en otros casos de manera presencial. Esta información se encontrará detallada en cada beneficio.`,
    },
    {
      topic: 'Condiciones de Uso del Programa',
      question: '¿Cómo accedo a las condiciones de uso del programa?',
      answer: `Podrás acceder haciendo clic <a href="https://shellbox.shell.com.ar/programa" target="_blank" rel="noopener noreferrer">acá</a>.`,
    },
    {
      topic: 'App Shell Box',
      question: '¿Cómo puedo pagar con Shell Box?',
      answer: `En Shell Box podrás abonar tus compras con tarjeta de débito, tarjeta de crédito o Mercado Pago. Recordá que para abonar con tarjeta de crédito o débito deberás previamente registrarla desde la opción "Medios de Pago" que se encuentra en el menú de inicio.`,
    },
    {
      topic: 'App Shell Box',
      question: '¿Cómo realizo una compra paso a paso?',
      answer: `<ol>
          <li>Descargá la App Shell Box y registrate.</li>
          <li>Cargá tu medio de pago en caso de abonar con tarjeta de débito o crédito.</li>
          <li>Hace clic en el botón "Pagar con la app" que se encuentra en la página de inicio.</li>
          <li>Apunta la cámara de tu teléfono celular al código QR presentado por el vendedor.</li>
          <li>Seleccioná el medio de pago con el que deseas abonar.</li>
          <li>Confirmá la compra.</li>
        </ol>`,
    },
    {
      topic: 'App Shell Box',
      question: '¿Qué beneficios obtengo con Shell Box?',
      answer: `<ol>
          <li>Pagar rápido y seguro.</li>
          <li>Acumular y canjear puntos Shell Box por descuentos exclusivos en V-Power, Lubricantes y productos de nuestras tiendas Shell Select.</li>
          <li>Canjear puntos Shell Box a Millas LATAM PASS y viceversa.</li>
          <li>Canjear puntos para vivir experiencias increíbles.</li>
        </ol>`,
    },
    {
      topic: 'Market Shell',
      question: '¿Qué es el Market Shell?',
      answer: `Una nueva tienda digital para adquirir productos y servicios especialmente diseñado para los Socios Shell Box para encontrar soluciones de movilidad y gran variedad de productos. ¡Vas a encontrar los mejores precios en bicicletas, accesorios, productos para tu hogar y mucho más! Además, podrás pagar parte de tus productos con Puntos Shell Box. Los Productos del Market Shell pueden ser ofrecidos por distintos Vendedores, quedando sujetos los plazos de entrega, precios de los mismos, sistema de pago y procesos de cambio o devolución a condiciones propias de cada Producto y/o Vendedor. Los precios y promociones que se ofrecen en el Market Shell, son exclusivos para el Sitio y pueden sufrir modificaciones.`,
    },
    {
      topic: 'Market Shell',
      question:
        '¿Los productos/servicios dentro del Market Shell se acceden únicamente con canje? ¿Hay una variable canje + pesos?',
      answer: `Se podrá acceder a los productos/servicios mediante puntos + pesos. Los puntos serán descontados de tu cuenta Shell Box y la parte en pesos se abonará con los medios habilitados que disponga el vendedor.`,
    },
    {
      topic: 'Market Shell',
      question:
        '¿Se necesita tener puntos acumulados para comprar en el Market Shell?',
      answer: `Market Shell es una tienda digital exclusiva para la comunidad de socios de Shell Box, para acceder a las ofertas disponibles es necesario contar con un mínimo de 100 puntos acumulados. También podrás utilizar los puntos acumulados para pagar parte de los productos que desees adquirir.`,
    },
    {
      topic: 'Centro de atención',
      question: '¿Cómo me contacto con el centro de atención Shell Box?',
      answer: `Podrás contactarte con nuestro Centro de atención al socio Shell Box llamando al <a href="tel:08103338652">0810 333 8652 (VOLÁ)</a>, enviando un correo a <a href="mailto:shellbox@raizen.com.ar">shellbox@raizen.com.ar</a>.`,
    },
  ];

  constructor() {}

  ngOnInit(): void {
    if (this.topics.length > 0) {
      this.selectedTopic = this.topics[0];
    }
  }

  selectTopic(topic: string): void {
    this.selectedTopic = topic;
  }

  isSelected(topic: string): boolean {
    return this.selectedTopic === topic;
  }

  onSearchTermChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.searchTerm = inputElement.value;

    if (this.searchTerm.trim()) {
      this.selectedTopic = null;
    }
  }

  getFilteredQuestions(): Question[] {
    let filteredQuestions = this.questions;

    if (this.searchTerm.trim()) {
      const lowerSearchTerm = this.searchTerm.toLowerCase();
      filteredQuestions = filteredQuestions.filter(
        (question) =>
          question.question.toLowerCase().includes(lowerSearchTerm) ||
          question.answer.toLowerCase().includes(lowerSearchTerm)
      );
    } else if (this.selectedTopic) {
      filteredQuestions = filteredQuestions.filter(
        (question) => question.topic === this.selectedTopic
      );
    }

    return filteredQuestions;
  }
}
